import { isRhinoNetworkError, isRhinoTimeoutError } from '../error';

import { request } from './request';

type PingUrlArgs = {
  timeout?: number;
  url: string;
};

export async function pingUrl({ timeout = 5000, url }: PingUrlArgs) {
  try {
    await request({
      url,
      method: 'get',
      timeout,
    });

    return true;
  } catch (error) {
    return !isRhinoNetworkError(error) && !isRhinoTimeoutError(error);
  }
}
